module.exports = __webpack_public_path__ + "static/media/logo.59f314b4.svg";